/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Faceta API
 * API мультитенантного admin-движка Faceta. Спека генерируется из типов Go и является контрактом для фронтенда.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CheckoutInputBody,
  CheckoutOutputBody,
  ConstantsOutputBody1,
  CreateInputBody3,
  CreateOutputBody,
  DeliveryCreateHeaders,
  DeliveryDeleteHeaders,
  DeliveryFacetsHeaders,
  DeliveryFacetsParams,
  DeliveryFileHeaders,
  DeliveryFileParams,
  DeliveryGiftCardBuyHeaders,
  DeliveryListHeaders,
  DeliveryListParams,
  DeliveryRecordHeaders,
  DeliveryRecordParams,
  DeliveryShopCancelHeaders,
  DeliveryShopCheckoutHeaders,
  DeliveryShopOrderHeaders,
  DeliveryShopOrdersHeaders,
  DeliveryShopPayHeaders,
  DeliveryShopQuoteHeaders,
  DeliveryShopReturnHeaders,
  DeliverySingleHeaders,
  DeliverySingleParams,
  DeliveryStageHeaders,
  DeliveryThumbParams,
  DeliveryUpdateHeaders,
  ErrorModel,
  FacetsOutputBody,
  GiftCardBuyInputBody,
  GiftCardCheckOutputBody,
  ItemBody,
  KeyBody,
  KeysOutputBody,
  ListOutputBody,
  MenusOutputBody1,
  MyOrdersOutputBody,
  OrderBody,
  PayInputBody,
  PayOutputBody,
  PreviewInputBody,
  QuoteInputBody,
  QuoteOutputBody,
  ReturnRequestInputBody,
  SchemaOutputBody,
  StockAlertInputBody,
  UpdateInputBody3,
  VisitorStageInputBody
} from '../model';

import { facetaFetch } from '../../http';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type recordsDeliveryPreviewResponse200 = {
  data: ItemBody
  status: 200
}

export type recordsDeliveryPreviewResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordsDeliveryPreviewResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordsDeliveryPreviewResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordsDeliveryPreviewResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordsDeliveryPreviewResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordsDeliveryPreviewResponseSuccess = (recordsDeliveryPreviewResponse200) & {
  headers: Headers;
};
export type recordsDeliveryPreviewResponseError = (recordsDeliveryPreviewResponse401 | recordsDeliveryPreviewResponse403 | recordsDeliveryPreviewResponse404 | recordsDeliveryPreviewResponse422 | recordsDeliveryPreviewResponse500) & {
  headers: Headers;
};

export type recordsDeliveryPreviewResponse = (recordsDeliveryPreviewResponseSuccess | recordsDeliveryPreviewResponseError)

export const getRecordsDeliveryPreviewUrl = (recordId: string,) => {




  return `/records/${recordId}/preview`
}

/**
 * Собирает несохранённые значения формы так же, как API выдачи с ключом предпросмотра: переводы, файлы-объекты, раскрытые ссылки и блоки. Ничего не сохраняет.
 * @summary Запись так, как её увидит сайт
 */
export const recordsDeliveryPreview = async (recordId: string,
    previewInputBody: NonReadonly<PreviewInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<recordsDeliveryPreviewResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<recordsDeliveryPreviewResponse>(getRecordsDeliveryPreviewUrl(recordId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(previewInputBody)
  }
);}





export const getRecordsDeliveryPreviewQueryKey = (recordId: string,
    previewInputBody?: NonReadonly<PreviewInputBody>,) => {
    return [
    'POST', `/records/${recordId}/preview`, previewInputBody
    ] as const;
    }


export const getRecordsDeliveryPreviewQueryOptions = <TData = Awaited<ReturnType<typeof recordsDeliveryPreview>>, TError = ErrorModel>(recordId: string,
    previewInputBody: NonReadonly<PreviewInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsDeliveryPreview>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordsDeliveryPreviewQueryKey(recordId,previewInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordsDeliveryPreview>>> = ({ signal }) => recordsDeliveryPreview(recordId,previewInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordsDeliveryPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordsDeliveryPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof recordsDeliveryPreview>>>
export type RecordsDeliveryPreviewQueryError = ErrorModel


export function useRecordsDeliveryPreview<TData = Awaited<ReturnType<typeof recordsDeliveryPreview>>, TError = ErrorModel>(
 recordId: string,
    previewInputBody: NonReadonly<PreviewInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsDeliveryPreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsDeliveryPreview>>,
          TError,
          Awaited<ReturnType<typeof recordsDeliveryPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsDeliveryPreview<TData = Awaited<ReturnType<typeof recordsDeliveryPreview>>, TError = ErrorModel>(
 recordId: string,
    previewInputBody: NonReadonly<PreviewInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsDeliveryPreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsDeliveryPreview>>,
          TError,
          Awaited<ReturnType<typeof recordsDeliveryPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsDeliveryPreview<TData = Awaited<ReturnType<typeof recordsDeliveryPreview>>, TError = ErrorModel>(
 recordId: string,
    previewInputBody: NonReadonly<PreviewInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsDeliveryPreview>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Запись так, как её увидит сайт
 */

export function useRecordsDeliveryPreview<TData = Awaited<ReturnType<typeof recordsDeliveryPreview>>, TError = ErrorModel>(
 recordId: string,
    previewInputBody: NonReadonly<PreviewInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsDeliveryPreview>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordsDeliveryPreviewQueryOptions(recordId,previewInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type siteKeysResponse200 = {
  data: KeysOutputBody
  status: 200
}

export type siteKeysResponse401 = {
  data: ErrorModel
  status: 401
}

export type siteKeysResponse403 = {
  data: ErrorModel
  status: 403
}

export type siteKeysResponse404 = {
  data: ErrorModel
  status: 404
}

export type siteKeysResponse422 = {
  data: ErrorModel
  status: 422
}

export type siteKeysResponse500 = {
  data: ErrorModel
  status: 500
}

export type siteKeysResponseSuccess = (siteKeysResponse200) & {
  headers: Headers;
};
export type siteKeysResponseError = (siteKeysResponse401 | siteKeysResponse403 | siteKeysResponse404 | siteKeysResponse422 | siteKeysResponse500) & {
  headers: Headers;
};

export type siteKeysResponse = (siteKeysResponseSuccess | siteKeysResponseError)

export const getSiteKeysUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/keys`
}

/**
 * Публичный ключ и ключ предпросмотра. Заводятся сами при первом открытии.
 * @summary Ключи API окружения
 */
export const siteKeys = async (id: string,
    kind: 'production' | 'development', options?: Parameters<typeof facetaFetch>[1]): Promise<siteKeysResponse> => {

  return facetaFetch<siteKeysResponse>(getSiteKeysUrl(id,kind),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSiteKeysQueryKey = (id: string,
    kind: 'production' | 'development',) => {
    return [
    `/sites/${id}/environments/${kind}/keys`
    ] as const;
    }


export const getSiteKeysQueryOptions = <TData = Awaited<ReturnType<typeof siteKeys>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteKeys>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSiteKeysQueryKey(id,kind);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof siteKeys>>> = ({ signal }) => siteKeys(id,kind, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof siteKeys>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SiteKeysQueryResult = NonNullable<Awaited<ReturnType<typeof siteKeys>>>
export type SiteKeysQueryError = ErrorModel


export function useSiteKeys<TData = Awaited<ReturnType<typeof siteKeys>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteKeys>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteKeys>>,
          TError,
          Awaited<ReturnType<typeof siteKeys>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteKeys<TData = Awaited<ReturnType<typeof siteKeys>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteKeys>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteKeys>>,
          TError,
          Awaited<ReturnType<typeof siteKeys>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteKeys<TData = Awaited<ReturnType<typeof siteKeys>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteKeys>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Ключи API окружения
 */

export function useSiteKeys<TData = Awaited<ReturnType<typeof siteKeys>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteKeys>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSiteKeysQueryOptions(id,kind,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type siteKeyRotateResponse200 = {
  data: KeyBody
  status: 200
}

export type siteKeyRotateResponse401 = {
  data: ErrorModel
  status: 401
}

export type siteKeyRotateResponse403 = {
  data: ErrorModel
  status: 403
}

export type siteKeyRotateResponse404 = {
  data: ErrorModel
  status: 404
}

export type siteKeyRotateResponse422 = {
  data: ErrorModel
  status: 422
}

export type siteKeyRotateResponse500 = {
  data: ErrorModel
  status: 500
}

export type siteKeyRotateResponseSuccess = (siteKeyRotateResponse200) & {
  headers: Headers;
};
export type siteKeyRotateResponseError = (siteKeyRotateResponse401 | siteKeyRotateResponse403 | siteKeyRotateResponse404 | siteKeyRotateResponse422 | siteKeyRotateResponse500) & {
  headers: Headers;
};

export type siteKeyRotateResponse = (siteKeyRotateResponseSuccess | siteKeyRotateResponseError)

export const getSiteKeyRotateUrl = (id: string,
    kind: 'production' | 'development',
    key: 'public' | 'preview',) => {




  return `/sites/${id}/environments/${kind}/keys/${key}/rotate`
}

/**
 * Прежний ключ перестаёт работать сразу — сайт с ним получит 401, пока в его .env не поставят новый.
 * @summary Заменить ключ
 */
export const siteKeyRotate = async (id: string,
    kind: 'production' | 'development',
    key: 'public' | 'preview', options?: Parameters<typeof facetaFetch>[1]): Promise<siteKeyRotateResponse> => {

  return facetaFetch<siteKeyRotateResponse>(getSiteKeyRotateUrl(id,kind,key),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSiteKeyRotateQueryKey = (id: string,
    kind: 'production' | 'development',
    key: 'public' | 'preview',) => {
    return [
    'POST', `/sites/${id}/environments/${kind}/keys/${key}/rotate`
    ] as const;
    }


export const getSiteKeyRotateQueryOptions = <TData = Awaited<ReturnType<typeof siteKeyRotate>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    key: 'public' | 'preview', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteKeyRotate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSiteKeyRotateQueryKey(id,kind,key);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof siteKeyRotate>>> = ({ signal }) => siteKeyRotate(id,kind,key, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined && key !== null && key !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof siteKeyRotate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SiteKeyRotateQueryResult = NonNullable<Awaited<ReturnType<typeof siteKeyRotate>>>
export type SiteKeyRotateQueryError = ErrorModel


export function useSiteKeyRotate<TData = Awaited<ReturnType<typeof siteKeyRotate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    key: 'public' | 'preview', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteKeyRotate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteKeyRotate>>,
          TError,
          Awaited<ReturnType<typeof siteKeyRotate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteKeyRotate<TData = Awaited<ReturnType<typeof siteKeyRotate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    key: 'public' | 'preview', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteKeyRotate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteKeyRotate>>,
          TError,
          Awaited<ReturnType<typeof siteKeyRotate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteKeyRotate<TData = Awaited<ReturnType<typeof siteKeyRotate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    key: 'public' | 'preview', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteKeyRotate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Заменить ключ
 */

export function useSiteKeyRotate<TData = Awaited<ReturnType<typeof siteKeyRotate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    key: 'public' | 'preview', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteKeyRotate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSiteKeyRotateQueryOptions(id,kind,key,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliveryListResponse200 = {
  data: ListOutputBody
  status: 200
}

export type deliveryListResponse401 = {
  data: ErrorModel
  status: 401
}

export type deliveryListResponse403 = {
  data: ErrorModel
  status: 403
}

export type deliveryListResponse404 = {
  data: ErrorModel
  status: 404
}

export type deliveryListResponse422 = {
  data: ErrorModel
  status: 422
}

export type deliveryListResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliveryListResponseSuccess = (deliveryListResponse200) & {
  headers: Headers;
};
export type deliveryListResponseError = (deliveryListResponse401 | deliveryListResponse403 | deliveryListResponse404 | deliveryListResponse422 | deliveryListResponse500) & {
  headers: Headers;
};

export type deliveryListResponse = (deliveryListResponseSuccess | deliveryListResponseError)

export const getDeliveryListUrl = (type: string,
    params?: DeliveryListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/collections/${type}?${stringifiedParams}` : `/v1/collections/${type}`
}

/**
 * С публичным ключом — только опубликованные и их опубликованные значения; с ключом предпросмотра — все, с черновиками. Фильтры и сортировка — по тем же значениям.
 * @summary Записи коллекции
 */
export const deliveryList = async (type: string,
    params?: DeliveryListParams,
    headers?: DeliveryListHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<deliveryListResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<deliveryListResponse>(getDeliveryListUrl(type,params),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);}





export const getDeliveryListQueryKey = (type: string,
    params?: DeliveryListParams,) => {
    return [
    `/v1/collections/${type}`, ...(params ? [params] : [])
    ] as const;
    }


export const getDeliveryListQueryOptions = <TData = Awaited<ReturnType<typeof deliveryList>>, TError = ErrorModel>(type: string,
    params?: DeliveryListParams,
    headers?: DeliveryListHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliveryListQueryKey(type,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliveryList>>> = ({ signal }) => deliveryList(type,params,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: type !== null && type !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliveryList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliveryListQueryResult = NonNullable<Awaited<ReturnType<typeof deliveryList>>>
export type DeliveryListQueryError = ErrorModel


export function useDeliveryList<TData = Awaited<ReturnType<typeof deliveryList>>, TError = ErrorModel>(
 type: string,
    params: undefined |  DeliveryListParams,
    headers: undefined |  DeliveryListHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryList>>,
          TError,
          Awaited<ReturnType<typeof deliveryList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryList<TData = Awaited<ReturnType<typeof deliveryList>>, TError = ErrorModel>(
 type: string,
    params?: DeliveryListParams,
    headers?: DeliveryListHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryList>>,
          TError,
          Awaited<ReturnType<typeof deliveryList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryList<TData = Awaited<ReturnType<typeof deliveryList>>, TError = ErrorModel>(
 type: string,
    params?: DeliveryListParams,
    headers?: DeliveryListHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Записи коллекции
 */

export function useDeliveryList<TData = Awaited<ReturnType<typeof deliveryList>>, TError = ErrorModel>(
 type: string,
    params?: DeliveryListParams,
    headers?: DeliveryListHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliveryListQueryOptions(type,params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliveryCreateResponse201 = {
  data: CreateOutputBody
  status: 201
}

export type deliveryCreateResponse401 = {
  data: ErrorModel
  status: 401
}

export type deliveryCreateResponse403 = {
  data: ErrorModel
  status: 403
}

export type deliveryCreateResponse404 = {
  data: ErrorModel
  status: 404
}

export type deliveryCreateResponse422 = {
  data: ErrorModel
  status: 422
}

export type deliveryCreateResponse429 = {
  data: ErrorModel
  status: 429
}

export type deliveryCreateResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliveryCreateResponseSuccess = (deliveryCreateResponse201) & {
  headers: Headers;
};
export type deliveryCreateResponseError = (deliveryCreateResponse401 | deliveryCreateResponse403 | deliveryCreateResponse404 | deliveryCreateResponse422 | deliveryCreateResponse429 | deliveryCreateResponse500) & {
  headers: Headers;
};

export type deliveryCreateResponse = (deliveryCreateResponseSuccess | deliveryCreateResponseError)

export const getDeliveryCreateUrl = (type: string,) => {




  return `/v1/collections/${type}`
}

/**
 * Заявка, отзыв, попытка теста — в коллекцию, где правило «создавать» открыто. Запись — черновик: на сайт не выходит, её видят в админке. Скрытые поля не задаются. С одного адреса — не больше 5 в минуту и 30 в час на коллекцию (429). Шлёт сервер сайта — адрес посетителя в заголовке X-Faceta-Visitor-IP (без Origin); с одного сервера — не больше 60 в минуту и 600 в час.
 * @summary Создать запись с сайта
 */
export const deliveryCreate = async (type: string,
    createInputBody3: NonReadonly<CreateInputBody3>,
    headers?: DeliveryCreateHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<deliveryCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<deliveryCreateResponse>(getDeliveryCreateUrl(type),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(createInputBody3)
  }
);}





export const getDeliveryCreateQueryKey = (type: string,
    createInputBody3?: NonReadonly<CreateInputBody3>,) => {
    return [
    'POST', `/v1/collections/${type}`, createInputBody3
    ] as const;
    }


export const getDeliveryCreateQueryOptions = <TData = Awaited<ReturnType<typeof deliveryCreate>>, TError = ErrorModel>(type: string,
    createInputBody3: NonReadonly<CreateInputBody3>,
    headers?: DeliveryCreateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliveryCreateQueryKey(type,createInputBody3);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliveryCreate>>> = ({ signal }) => deliveryCreate(type,createInputBody3,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: type !== null && type !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliveryCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliveryCreateQueryResult = NonNullable<Awaited<ReturnType<typeof deliveryCreate>>>
export type DeliveryCreateQueryError = ErrorModel


export function useDeliveryCreate<TData = Awaited<ReturnType<typeof deliveryCreate>>, TError = ErrorModel>(
 type: string,
    createInputBody3: NonReadonly<CreateInputBody3>,
    headers: undefined |  DeliveryCreateHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryCreate>>,
          TError,
          Awaited<ReturnType<typeof deliveryCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryCreate<TData = Awaited<ReturnType<typeof deliveryCreate>>, TError = ErrorModel>(
 type: string,
    createInputBody3: NonReadonly<CreateInputBody3>,
    headers?: DeliveryCreateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryCreate>>,
          TError,
          Awaited<ReturnType<typeof deliveryCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryCreate<TData = Awaited<ReturnType<typeof deliveryCreate>>, TError = ErrorModel>(
 type: string,
    createInputBody3: NonReadonly<CreateInputBody3>,
    headers?: DeliveryCreateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Создать запись с сайта
 */

export function useDeliveryCreate<TData = Awaited<ReturnType<typeof deliveryCreate>>, TError = ErrorModel>(
 type: string,
    createInputBody3: NonReadonly<CreateInputBody3>,
    headers?: DeliveryCreateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliveryCreateQueryOptions(type,createInputBody3,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliveryDeleteResponse204 = {
  data: void
  status: 204
}

export type deliveryDeleteResponse401 = {
  data: ErrorModel
  status: 401
}

export type deliveryDeleteResponse403 = {
  data: ErrorModel
  status: 403
}

export type deliveryDeleteResponse404 = {
  data: ErrorModel
  status: 404
}

export type deliveryDeleteResponse422 = {
  data: ErrorModel
  status: 422
}

export type deliveryDeleteResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliveryDeleteResponseSuccess = (deliveryDeleteResponse204) & {
  headers: Headers;
};
export type deliveryDeleteResponseError = (deliveryDeleteResponse401 | deliveryDeleteResponse403 | deliveryDeleteResponse404 | deliveryDeleteResponse422 | deliveryDeleteResponse500) & {
  headers: Headers;
};

export type deliveryDeleteResponse = (deliveryDeleteResponseSuccess | deliveryDeleteResponseError)

export const getDeliveryDeleteUrl = (type: string,
    record: string,) => {




  return `/v1/collections/${type}/${record}`
}

/**
 * Где правило «удалять: только своё». Запись уходит в корзину — в админке её можно вернуть.
 * @summary Удалить свою запись
 */
export const deliveryDelete = async (type: string,
    record: string,
    headers?: DeliveryDeleteHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<deliveryDeleteResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<deliveryDeleteResponse>(getDeliveryDeleteUrl(type,record),
  {
    ...options,
    method: 'DELETE',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);}





export const getDeliveryDeleteQueryKey = (type: string,
    record: string,) => {
    return [
    'DELETE', `/v1/collections/${type}/${record}`
    ] as const;
    }


export const getDeliveryDeleteQueryOptions = <TData = Awaited<ReturnType<typeof deliveryDelete>>, TError = ErrorModel>(type: string,
    record: string,
    headers?: DeliveryDeleteHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliveryDeleteQueryKey(type,record);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliveryDelete>>> = ({ signal }) => deliveryDelete(type,record,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: type !== null && type !== undefined && record !== null && record !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliveryDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliveryDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof deliveryDelete>>>
export type DeliveryDeleteQueryError = ErrorModel


export function useDeliveryDelete<TData = Awaited<ReturnType<typeof deliveryDelete>>, TError = ErrorModel>(
 type: string,
    record: string,
    headers: undefined |  DeliveryDeleteHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryDelete>>,
          TError,
          Awaited<ReturnType<typeof deliveryDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryDelete<TData = Awaited<ReturnType<typeof deliveryDelete>>, TError = ErrorModel>(
 type: string,
    record: string,
    headers?: DeliveryDeleteHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryDelete>>,
          TError,
          Awaited<ReturnType<typeof deliveryDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryDelete<TData = Awaited<ReturnType<typeof deliveryDelete>>, TError = ErrorModel>(
 type: string,
    record: string,
    headers?: DeliveryDeleteHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Удалить свою запись
 */

export function useDeliveryDelete<TData = Awaited<ReturnType<typeof deliveryDelete>>, TError = ErrorModel>(
 type: string,
    record: string,
    headers?: DeliveryDeleteHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliveryDeleteQueryOptions(type,record,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliveryRecordResponse200 = {
  data: ItemBody
  status: 200
}

export type deliveryRecordResponse401 = {
  data: ErrorModel
  status: 401
}

export type deliveryRecordResponse403 = {
  data: ErrorModel
  status: 403
}

export type deliveryRecordResponse404 = {
  data: ErrorModel
  status: 404
}

export type deliveryRecordResponse422 = {
  data: ErrorModel
  status: 422
}

export type deliveryRecordResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliveryRecordResponseSuccess = (deliveryRecordResponse200) & {
  headers: Headers;
};
export type deliveryRecordResponseError = (deliveryRecordResponse401 | deliveryRecordResponse403 | deliveryRecordResponse404 | deliveryRecordResponse422 | deliveryRecordResponse500) & {
  headers: Headers;
};

export type deliveryRecordResponse = (deliveryRecordResponseSuccess | deliveryRecordResponseError)

export const getDeliveryRecordUrl = (type: string,
    record: string,
    params?: DeliveryRecordParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/collections/${type}/${record}?${stringifiedParams}` : `/v1/collections/${type}/${record}`
}

/**
 * @summary Запись коллекции
 */
export const deliveryRecord = async (type: string,
    record: string,
    params?: DeliveryRecordParams,
    headers?: DeliveryRecordHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<deliveryRecordResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<deliveryRecordResponse>(getDeliveryRecordUrl(type,record,params),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);}





export const getDeliveryRecordQueryKey = (type: string,
    record: string,
    params?: DeliveryRecordParams,) => {
    return [
    `/v1/collections/${type}/${record}`, ...(params ? [params] : [])
    ] as const;
    }


export const getDeliveryRecordQueryOptions = <TData = Awaited<ReturnType<typeof deliveryRecord>>, TError = ErrorModel>(type: string,
    record: string,
    params?: DeliveryRecordParams,
    headers?: DeliveryRecordHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryRecord>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliveryRecordQueryKey(type,record,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliveryRecord>>> = ({ signal }) => deliveryRecord(type,record,params,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: type !== null && type !== undefined && record !== null && record !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliveryRecord>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliveryRecordQueryResult = NonNullable<Awaited<ReturnType<typeof deliveryRecord>>>
export type DeliveryRecordQueryError = ErrorModel


export function useDeliveryRecord<TData = Awaited<ReturnType<typeof deliveryRecord>>, TError = ErrorModel>(
 type: string,
    record: string,
    params: undefined |  DeliveryRecordParams,
    headers: undefined |  DeliveryRecordHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryRecord>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryRecord>>,
          TError,
          Awaited<ReturnType<typeof deliveryRecord>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryRecord<TData = Awaited<ReturnType<typeof deliveryRecord>>, TError = ErrorModel>(
 type: string,
    record: string,
    params?: DeliveryRecordParams,
    headers?: DeliveryRecordHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryRecord>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryRecord>>,
          TError,
          Awaited<ReturnType<typeof deliveryRecord>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryRecord<TData = Awaited<ReturnType<typeof deliveryRecord>>, TError = ErrorModel>(
 type: string,
    record: string,
    params?: DeliveryRecordParams,
    headers?: DeliveryRecordHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryRecord>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Запись коллекции
 */

export function useDeliveryRecord<TData = Awaited<ReturnType<typeof deliveryRecord>>, TError = ErrorModel>(
 type: string,
    record: string,
    params?: DeliveryRecordParams,
    headers?: DeliveryRecordHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryRecord>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliveryRecordQueryOptions(type,record,params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliveryUpdateResponse200 = {
  data: ItemBody
  status: 200
}

export type deliveryUpdateResponse401 = {
  data: ErrorModel
  status: 401
}

export type deliveryUpdateResponse403 = {
  data: ErrorModel
  status: 403
}

export type deliveryUpdateResponse404 = {
  data: ErrorModel
  status: 404
}

export type deliveryUpdateResponse422 = {
  data: ErrorModel
  status: 422
}

export type deliveryUpdateResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliveryUpdateResponseSuccess = (deliveryUpdateResponse200) & {
  headers: Headers;
};
export type deliveryUpdateResponseError = (deliveryUpdateResponse401 | deliveryUpdateResponse403 | deliveryUpdateResponse404 | deliveryUpdateResponse422 | deliveryUpdateResponse500) & {
  headers: Headers;
};

export type deliveryUpdateResponse = (deliveryUpdateResponseSuccess | deliveryUpdateResponseError)

export const getDeliveryUpdateUrl = (type: string,
    record: string,) => {




  return `/v1/collections/${type}/${record}`
}

/**
 * Где правило «менять: только своё»: вошедший посетитель меняет записи, которые создал сам. Правка — черновик: посетителю она видна сразу, на сайте для всех — после публикации в админке.
 * @summary Изменить свою запись
 */
export const deliveryUpdate = async (type: string,
    record: string,
    updateInputBody3: NonReadonly<UpdateInputBody3>,
    headers?: DeliveryUpdateHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<deliveryUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<deliveryUpdateResponse>(getDeliveryUpdateUrl(type,record),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(updateInputBody3)
  }
);}





export const getDeliveryUpdateQueryKey = (type: string,
    record: string,
    updateInputBody3?: NonReadonly<UpdateInputBody3>,) => {
    return [
    'PATCH', `/v1/collections/${type}/${record}`, updateInputBody3
    ] as const;
    }


export const getDeliveryUpdateQueryOptions = <TData = Awaited<ReturnType<typeof deliveryUpdate>>, TError = ErrorModel>(type: string,
    record: string,
    updateInputBody3: NonReadonly<UpdateInputBody3>,
    headers?: DeliveryUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliveryUpdateQueryKey(type,record,updateInputBody3);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliveryUpdate>>> = ({ signal }) => deliveryUpdate(type,record,updateInputBody3,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: type !== null && type !== undefined && record !== null && record !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliveryUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliveryUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof deliveryUpdate>>>
export type DeliveryUpdateQueryError = ErrorModel


export function useDeliveryUpdate<TData = Awaited<ReturnType<typeof deliveryUpdate>>, TError = ErrorModel>(
 type: string,
    record: string,
    updateInputBody3: NonReadonly<UpdateInputBody3>,
    headers: undefined |  DeliveryUpdateHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryUpdate>>,
          TError,
          Awaited<ReturnType<typeof deliveryUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryUpdate<TData = Awaited<ReturnType<typeof deliveryUpdate>>, TError = ErrorModel>(
 type: string,
    record: string,
    updateInputBody3: NonReadonly<UpdateInputBody3>,
    headers?: DeliveryUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryUpdate>>,
          TError,
          Awaited<ReturnType<typeof deliveryUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryUpdate<TData = Awaited<ReturnType<typeof deliveryUpdate>>, TError = ErrorModel>(
 type: string,
    record: string,
    updateInputBody3: NonReadonly<UpdateInputBody3>,
    headers?: DeliveryUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Изменить свою запись
 */

export function useDeliveryUpdate<TData = Awaited<ReturnType<typeof deliveryUpdate>>, TError = ErrorModel>(
 type: string,
    record: string,
    updateInputBody3: NonReadonly<UpdateInputBody3>,
    headers?: DeliveryUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliveryUpdateQueryOptions(type,record,updateInputBody3,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliveryStageResponse200 = {
  data: ItemBody
  status: 200
}

export type deliveryStageResponse401 = {
  data: ErrorModel
  status: 401
}

export type deliveryStageResponse403 = {
  data: ErrorModel
  status: 403
}

export type deliveryStageResponse404 = {
  data: ErrorModel
  status: 404
}

export type deliveryStageResponse409 = {
  data: ErrorModel
  status: 409
}

export type deliveryStageResponse422 = {
  data: ErrorModel
  status: 422
}

export type deliveryStageResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliveryStageResponseSuccess = (deliveryStageResponse200) & {
  headers: Headers;
};
export type deliveryStageResponseError = (deliveryStageResponse401 | deliveryStageResponse403 | deliveryStageResponse404 | deliveryStageResponse409 | deliveryStageResponse422 | deliveryStageResponse500) & {
  headers: Headers;
};

export type deliveryStageResponse = (deliveryStageResponseSuccess | deliveryStageResponseError)

export const getDeliveryStageUrl = (type: string,
    record: string,) => {




  return `/v1/collections/${type}/${record}/stage`
}

/**
 * Только по переходу, открытому посетителю (в записи — stage.actions): «Отменить заказ», «Отправить на проверку». Запись — своя.
 * @summary Сменить статус своей записи
 */
export const deliveryStage = async (type: string,
    record: string,
    visitorStageInputBody: NonReadonly<VisitorStageInputBody>,
    headers?: DeliveryStageHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<deliveryStageResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<deliveryStageResponse>(getDeliveryStageUrl(type,record),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(visitorStageInputBody)
  }
);}





export const getDeliveryStageQueryKey = (type: string,
    record: string,
    visitorStageInputBody?: NonReadonly<VisitorStageInputBody>,) => {
    return [
    'POST', `/v1/collections/${type}/${record}/stage`, visitorStageInputBody
    ] as const;
    }


export const getDeliveryStageQueryOptions = <TData = Awaited<ReturnType<typeof deliveryStage>>, TError = ErrorModel>(type: string,
    record: string,
    visitorStageInputBody: NonReadonly<VisitorStageInputBody>,
    headers?: DeliveryStageHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryStage>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliveryStageQueryKey(type,record,visitorStageInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliveryStage>>> = ({ signal }) => deliveryStage(type,record,visitorStageInputBody,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: type !== null && type !== undefined && record !== null && record !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliveryStage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliveryStageQueryResult = NonNullable<Awaited<ReturnType<typeof deliveryStage>>>
export type DeliveryStageQueryError = ErrorModel


export function useDeliveryStage<TData = Awaited<ReturnType<typeof deliveryStage>>, TError = ErrorModel>(
 type: string,
    record: string,
    visitorStageInputBody: NonReadonly<VisitorStageInputBody>,
    headers: undefined |  DeliveryStageHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryStage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryStage>>,
          TError,
          Awaited<ReturnType<typeof deliveryStage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryStage<TData = Awaited<ReturnType<typeof deliveryStage>>, TError = ErrorModel>(
 type: string,
    record: string,
    visitorStageInputBody: NonReadonly<VisitorStageInputBody>,
    headers?: DeliveryStageHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryStage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryStage>>,
          TError,
          Awaited<ReturnType<typeof deliveryStage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryStage<TData = Awaited<ReturnType<typeof deliveryStage>>, TError = ErrorModel>(
 type: string,
    record: string,
    visitorStageInputBody: NonReadonly<VisitorStageInputBody>,
    headers?: DeliveryStageHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryStage>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Сменить статус своей записи
 */

export function useDeliveryStage<TData = Awaited<ReturnType<typeof deliveryStage>>, TError = ErrorModel>(
 type: string,
    record: string,
    visitorStageInputBody: NonReadonly<VisitorStageInputBody>,
    headers?: DeliveryStageHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryStage>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliveryStageQueryOptions(type,record,visitorStageInputBody,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliveryConstantsResponse200 = {
  data: ConstantsOutputBody1
  status: 200
}

export type deliveryConstantsResponse401 = {
  data: ErrorModel
  status: 401
}

export type deliveryConstantsResponse403 = {
  data: ErrorModel
  status: 403
}

export type deliveryConstantsResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliveryConstantsResponseSuccess = (deliveryConstantsResponse200) & {
  headers: Headers;
};
export type deliveryConstantsResponseError = (deliveryConstantsResponse401 | deliveryConstantsResponse403 | deliveryConstantsResponse500) & {
  headers: Headers;
};

export type deliveryConstantsResponse = (deliveryConstantsResponseSuccess | deliveryConstantsResponseError)

export const getDeliveryConstantsUrl = () => {




  return `/v1/constants`
}

/**
 * Телефон, почта, соцсети — все константы окружения одним ответом. Черновиков у констант нет: ключ предпросмотра видит то же, что публичный.
 * @summary Константы сайта
 */
export const deliveryConstants = async ( options?: Parameters<typeof facetaFetch>[1]): Promise<deliveryConstantsResponse> => {

  return facetaFetch<deliveryConstantsResponse>(getDeliveryConstantsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDeliveryConstantsQueryKey = () => {
    return [
    `/v1/constants`
    ] as const;
    }


export const getDeliveryConstantsQueryOptions = <TData = Awaited<ReturnType<typeof deliveryConstants>>, TError = ErrorModel>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryConstants>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliveryConstantsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliveryConstants>>> = ({ signal }) => deliveryConstants({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliveryConstants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliveryConstantsQueryResult = NonNullable<Awaited<ReturnType<typeof deliveryConstants>>>
export type DeliveryConstantsQueryError = ErrorModel


export function useDeliveryConstants<TData = Awaited<ReturnType<typeof deliveryConstants>>, TError = ErrorModel>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryConstants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryConstants>>,
          TError,
          Awaited<ReturnType<typeof deliveryConstants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryConstants<TData = Awaited<ReturnType<typeof deliveryConstants>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryConstants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryConstants>>,
          TError,
          Awaited<ReturnType<typeof deliveryConstants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryConstants<TData = Awaited<ReturnType<typeof deliveryConstants>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryConstants>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Константы сайта
 */

export function useDeliveryConstants<TData = Awaited<ReturnType<typeof deliveryConstants>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryConstants>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliveryConstantsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliveryFacetsResponse200 = {
  data: FacetsOutputBody
  status: 200
}

export type deliveryFacetsResponse401 = {
  data: ErrorModel
  status: 401
}

export type deliveryFacetsResponse403 = {
  data: ErrorModel
  status: 403
}

export type deliveryFacetsResponse404 = {
  data: ErrorModel
  status: 404
}

export type deliveryFacetsResponse422 = {
  data: ErrorModel
  status: 422
}

export type deliveryFacetsResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliveryFacetsResponseSuccess = (deliveryFacetsResponse200) & {
  headers: Headers;
};
export type deliveryFacetsResponseError = (deliveryFacetsResponse401 | deliveryFacetsResponse403 | deliveryFacetsResponse404 | deliveryFacetsResponse422 | deliveryFacetsResponse500) & {
  headers: Headers;
};

export type deliveryFacetsResponse = (deliveryFacetsResponseSuccess | deliveryFacetsResponseError)

export const getDeliveryFacetsUrl = (type: string,
    params?: DeliveryFacetsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/facets/${type}?${stringifiedParams}` : `/v1/facets/${type}`
}

/**
 * Те же параметры, что у списка коллекции (filters, search, in_stock, variant, sale…), плюс какие фасеты нужны. У каждого фасета его собственное условие не учитывается — видно, сколько будет при другом выборе.
 * @summary Сколько записей у значений фильтров
 */
export const deliveryFacets = async (type: string,
    params?: DeliveryFacetsParams,
    headers?: DeliveryFacetsHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<deliveryFacetsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<deliveryFacetsResponse>(getDeliveryFacetsUrl(type,params),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);}





export const getDeliveryFacetsQueryKey = (type: string,
    params?: DeliveryFacetsParams,) => {
    return [
    `/v1/facets/${type}`, ...(params ? [params] : [])
    ] as const;
    }


export const getDeliveryFacetsQueryOptions = <TData = Awaited<ReturnType<typeof deliveryFacets>>, TError = ErrorModel>(type: string,
    params?: DeliveryFacetsParams,
    headers?: DeliveryFacetsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryFacets>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliveryFacetsQueryKey(type,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliveryFacets>>> = ({ signal }) => deliveryFacets(type,params,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: type !== null && type !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliveryFacets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliveryFacetsQueryResult = NonNullable<Awaited<ReturnType<typeof deliveryFacets>>>
export type DeliveryFacetsQueryError = ErrorModel


export function useDeliveryFacets<TData = Awaited<ReturnType<typeof deliveryFacets>>, TError = ErrorModel>(
 type: string,
    params: undefined |  DeliveryFacetsParams,
    headers: undefined |  DeliveryFacetsHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryFacets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryFacets>>,
          TError,
          Awaited<ReturnType<typeof deliveryFacets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryFacets<TData = Awaited<ReturnType<typeof deliveryFacets>>, TError = ErrorModel>(
 type: string,
    params?: DeliveryFacetsParams,
    headers?: DeliveryFacetsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryFacets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryFacets>>,
          TError,
          Awaited<ReturnType<typeof deliveryFacets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryFacets<TData = Awaited<ReturnType<typeof deliveryFacets>>, TError = ErrorModel>(
 type: string,
    params?: DeliveryFacetsParams,
    headers?: DeliveryFacetsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryFacets>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Сколько записей у значений фильтров
 */

export function useDeliveryFacets<TData = Awaited<ReturnType<typeof deliveryFacets>>, TError = ErrorModel>(
 type: string,
    params?: DeliveryFacetsParams,
    headers?: DeliveryFacetsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryFacets>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliveryFacetsQueryOptions(type,params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliveryFileResponse200 = {
  data: void
  status: 200
}

export type deliveryFileResponse404 = {
  data: ErrorModel
  status: 404
}

export type deliveryFileResponse422 = {
  data: ErrorModel
  status: 422
}

export type deliveryFileResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliveryFileResponseSuccess = (deliveryFileResponse200) & {
  headers: Headers;
};
export type deliveryFileResponseError = (deliveryFileResponse404 | deliveryFileResponse422 | deliveryFileResponse500) & {
  headers: Headers;
};

export type deliveryFileResponse = (deliveryFileResponseSuccess | deliveryFileResponseError)

export const getDeliveryFileUrl = (fileId: string,
    params?: DeliveryFileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/files/${fileId}?${stringifiedParams}` : `/v1/files/${fileId}`
}

/**
 * Без ключа — адрес ставится в <img src>. Картинку можно попросить уменьшенной (w) и обрезанной до пропорции (w и h) вокруг точки фокуса. Ответ кешируется браузером и CDN навсегда: содержимое под идентификатором не меняется.
 * @summary Файл для сайта
 */
export const deliveryFile = async (fileId: string,
    params?: DeliveryFileParams,
    headers?: DeliveryFileHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<deliveryFileResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<deliveryFileResponse>(getDeliveryFileUrl(fileId,params),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);}





export const getDeliveryFileQueryKey = (fileId: string,
    params?: DeliveryFileParams,) => {
    return [
    `/v1/files/${fileId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getDeliveryFileQueryOptions = <TData = Awaited<ReturnType<typeof deliveryFile>>, TError = ErrorModel>(fileId: string,
    params?: DeliveryFileParams,
    headers?: DeliveryFileHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryFile>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliveryFileQueryKey(fileId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliveryFile>>> = ({ signal }) => deliveryFile(fileId,params,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: fileId !== null && fileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliveryFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliveryFileQueryResult = NonNullable<Awaited<ReturnType<typeof deliveryFile>>>
export type DeliveryFileQueryError = ErrorModel


export function useDeliveryFile<TData = Awaited<ReturnType<typeof deliveryFile>>, TError = ErrorModel>(
 fileId: string,
    params: undefined |  DeliveryFileParams,
    headers: undefined |  DeliveryFileHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryFile>>,
          TError,
          Awaited<ReturnType<typeof deliveryFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryFile<TData = Awaited<ReturnType<typeof deliveryFile>>, TError = ErrorModel>(
 fileId: string,
    params?: DeliveryFileParams,
    headers?: DeliveryFileHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryFile>>,
          TError,
          Awaited<ReturnType<typeof deliveryFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryFile<TData = Awaited<ReturnType<typeof deliveryFile>>, TError = ErrorModel>(
 fileId: string,
    params?: DeliveryFileParams,
    headers?: DeliveryFileHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryFile>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Файл для сайта
 */

export function useDeliveryFile<TData = Awaited<ReturnType<typeof deliveryFile>>, TError = ErrorModel>(
 fileId: string,
    params?: DeliveryFileParams,
    headers?: DeliveryFileHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryFile>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliveryFileQueryOptions(fileId,params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliveryHLSResponse200 = {
  data: void
  status: 200
}

export type deliveryHLSResponse404 = {
  data: ErrorModel
  status: 404
}

export type deliveryHLSResponse422 = {
  data: ErrorModel
  status: 422
}

export type deliveryHLSResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliveryHLSResponseSuccess = (deliveryHLSResponse200) & {
  headers: Headers;
};
export type deliveryHLSResponseError = (deliveryHLSResponse404 | deliveryHLSResponse422 | deliveryHLSResponse500) & {
  headers: Headers;
};

export type deliveryHLSResponse = (deliveryHLSResponseSuccess | deliveryHLSResponseError)

export const getDeliveryHLSUrl = (fileId: string,
    name: string,) => {




  return `/v1/files/${fileId}/hls/${name}`
}

/**
 * master.m3u8 — для плеера: он сам выбирает качество под скорость сети и грузит видео кусками. Есть, когда перекодировка готова (поле hls у видео).
 * @summary Видео в HLS
 */
export const deliveryHLS = async (fileId: string,
    name: string, options?: Parameters<typeof facetaFetch>[1]): Promise<deliveryHLSResponse> => {

  return facetaFetch<deliveryHLSResponse>(getDeliveryHLSUrl(fileId,name),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDeliveryHLSQueryKey = (fileId: string,
    name: string,) => {
    return [
    `/v1/files/${fileId}/hls/${name}`
    ] as const;
    }


export const getDeliveryHLSQueryOptions = <TData = Awaited<ReturnType<typeof deliveryHLS>>, TError = ErrorModel>(fileId: string,
    name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryHLS>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliveryHLSQueryKey(fileId,name);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliveryHLS>>> = ({ signal }) => deliveryHLS(fileId,name, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: fileId !== null && fileId !== undefined && name !== null && name !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliveryHLS>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliveryHLSQueryResult = NonNullable<Awaited<ReturnType<typeof deliveryHLS>>>
export type DeliveryHLSQueryError = ErrorModel


export function useDeliveryHLS<TData = Awaited<ReturnType<typeof deliveryHLS>>, TError = ErrorModel>(
 fileId: string,
    name: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryHLS>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryHLS>>,
          TError,
          Awaited<ReturnType<typeof deliveryHLS>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryHLS<TData = Awaited<ReturnType<typeof deliveryHLS>>, TError = ErrorModel>(
 fileId: string,
    name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryHLS>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryHLS>>,
          TError,
          Awaited<ReturnType<typeof deliveryHLS>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryHLS<TData = Awaited<ReturnType<typeof deliveryHLS>>, TError = ErrorModel>(
 fileId: string,
    name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryHLS>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Видео в HLS
 */

export function useDeliveryHLS<TData = Awaited<ReturnType<typeof deliveryHLS>>, TError = ErrorModel>(
 fileId: string,
    name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryHLS>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliveryHLSQueryOptions(fileId,name,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliveryHLSVersionedResponse200 = {
  data: void
  status: 200
}

export type deliveryHLSVersionedResponse404 = {
  data: ErrorModel
  status: 404
}

export type deliveryHLSVersionedResponse422 = {
  data: ErrorModel
  status: 422
}

export type deliveryHLSVersionedResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliveryHLSVersionedResponseSuccess = (deliveryHLSVersionedResponse200) & {
  headers: Headers;
};
export type deliveryHLSVersionedResponseError = (deliveryHLSVersionedResponse404 | deliveryHLSVersionedResponse422 | deliveryHLSVersionedResponse500) & {
  headers: Headers;
};

export type deliveryHLSVersionedResponse = (deliveryHLSVersionedResponseSuccess | deliveryHLSVersionedResponseError)

export const getDeliveryHLSVersionedUrl = (fileId: string,
    version: string,
    name: string,) => {




  return `/v1/files/${fileId}/hls/${version}/${name}`
}

/**
 * Так выглядит адрес в поле hls: версия в пути, чтобы после замены видео плеер не взял старые куски из кеша.
 * @summary Видео в HLS, с версией
 */
export const deliveryHLSVersioned = async (fileId: string,
    version: string,
    name: string, options?: Parameters<typeof facetaFetch>[1]): Promise<deliveryHLSVersionedResponse> => {

  return facetaFetch<deliveryHLSVersionedResponse>(getDeliveryHLSVersionedUrl(fileId,version,name),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDeliveryHLSVersionedQueryKey = (fileId: string,
    version: string,
    name: string,) => {
    return [
    `/v1/files/${fileId}/hls/${version}/${name}`
    ] as const;
    }


export const getDeliveryHLSVersionedQueryOptions = <TData = Awaited<ReturnType<typeof deliveryHLSVersioned>>, TError = ErrorModel>(fileId: string,
    version: string,
    name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryHLSVersioned>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliveryHLSVersionedQueryKey(fileId,version,name);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliveryHLSVersioned>>> = ({ signal }) => deliveryHLSVersioned(fileId,version,name, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: fileId !== null && fileId !== undefined && version !== null && version !== undefined && name !== null && name !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliveryHLSVersioned>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliveryHLSVersionedQueryResult = NonNullable<Awaited<ReturnType<typeof deliveryHLSVersioned>>>
export type DeliveryHLSVersionedQueryError = ErrorModel


export function useDeliveryHLSVersioned<TData = Awaited<ReturnType<typeof deliveryHLSVersioned>>, TError = ErrorModel>(
 fileId: string,
    version: string,
    name: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryHLSVersioned>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryHLSVersioned>>,
          TError,
          Awaited<ReturnType<typeof deliveryHLSVersioned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryHLSVersioned<TData = Awaited<ReturnType<typeof deliveryHLSVersioned>>, TError = ErrorModel>(
 fileId: string,
    version: string,
    name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryHLSVersioned>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryHLSVersioned>>,
          TError,
          Awaited<ReturnType<typeof deliveryHLSVersioned>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryHLSVersioned<TData = Awaited<ReturnType<typeof deliveryHLSVersioned>>, TError = ErrorModel>(
 fileId: string,
    version: string,
    name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryHLSVersioned>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Видео в HLS, с версией
 */

export function useDeliveryHLSVersioned<TData = Awaited<ReturnType<typeof deliveryHLSVersioned>>, TError = ErrorModel>(
 fileId: string,
    version: string,
    name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryHLSVersioned>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliveryHLSVersionedQueryOptions(fileId,version,name,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliveryThumbResponse200 = {
  data: void
  status: 200
}

export type deliveryThumbResponse404 = {
  data: ErrorModel
  status: 404
}

export type deliveryThumbResponse422 = {
  data: ErrorModel
  status: 422
}

export type deliveryThumbResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliveryThumbResponseSuccess = (deliveryThumbResponse200) & {
  headers: Headers;
};
export type deliveryThumbResponseError = (deliveryThumbResponse404 | deliveryThumbResponse422 | deliveryThumbResponse500) & {
  headers: Headers;
};

export type deliveryThumbResponse = (deliveryThumbResponseSuccess | deliveryThumbResponseError)

export const getDeliveryThumbUrl = (fileId: string,
    params?: DeliveryThumbParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/files/${fileId}/thumb?${stringifiedParams}` : `/v1/files/${fileId}/thumb`
}

/**
 * У видео — кадр, вырезанный при перекодировке (поле thumb у видео).
 * @summary Превью файла
 */
export const deliveryThumb = async (fileId: string,
    params?: DeliveryThumbParams, options?: Parameters<typeof facetaFetch>[1]): Promise<deliveryThumbResponse> => {

  return facetaFetch<deliveryThumbResponse>(getDeliveryThumbUrl(fileId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDeliveryThumbQueryKey = (fileId: string,
    params?: DeliveryThumbParams,) => {
    return [
    `/v1/files/${fileId}/thumb`, ...(params ? [params] : [])
    ] as const;
    }


export const getDeliveryThumbQueryOptions = <TData = Awaited<ReturnType<typeof deliveryThumb>>, TError = ErrorModel>(fileId: string,
    params?: DeliveryThumbParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryThumb>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliveryThumbQueryKey(fileId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliveryThumb>>> = ({ signal }) => deliveryThumb(fileId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: fileId !== null && fileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliveryThumb>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliveryThumbQueryResult = NonNullable<Awaited<ReturnType<typeof deliveryThumb>>>
export type DeliveryThumbQueryError = ErrorModel


export function useDeliveryThumb<TData = Awaited<ReturnType<typeof deliveryThumb>>, TError = ErrorModel>(
 fileId: string,
    params: undefined |  DeliveryThumbParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryThumb>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryThumb>>,
          TError,
          Awaited<ReturnType<typeof deliveryThumb>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryThumb<TData = Awaited<ReturnType<typeof deliveryThumb>>, TError = ErrorModel>(
 fileId: string,
    params?: DeliveryThumbParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryThumb>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryThumb>>,
          TError,
          Awaited<ReturnType<typeof deliveryThumb>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryThumb<TData = Awaited<ReturnType<typeof deliveryThumb>>, TError = ErrorModel>(
 fileId: string,
    params?: DeliveryThumbParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryThumb>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Превью файла
 */

export function useDeliveryThumb<TData = Awaited<ReturnType<typeof deliveryThumb>>, TError = ErrorModel>(
 fileId: string,
    params?: DeliveryThumbParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryThumb>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliveryThumbQueryOptions(fileId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliveryMenusResponse200 = {
  data: MenusOutputBody1
  status: 200
}

export type deliveryMenusResponse401 = {
  data: ErrorModel
  status: 401
}

export type deliveryMenusResponse403 = {
  data: ErrorModel
  status: 403
}

export type deliveryMenusResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliveryMenusResponseSuccess = (deliveryMenusResponse200) & {
  headers: Headers;
};
export type deliveryMenusResponseError = (deliveryMenusResponse401 | deliveryMenusResponse403 | deliveryMenusResponse500) & {
  headers: Headers;
};

export type deliveryMenusResponse = (deliveryMenusResponseSuccess | deliveryMenusResponseError)

export const getDeliveryMenusUrl = () => {




  return `/v1/menus`
}

/**
 * Все меню окружения одним ответом, адреса — готовые. Пункт на запись, которую сайт не видит (черновик для публичного ключа, корзина) или у модели которой нет адреса, пропускается вместе с вложенными.
 * @summary Меню сайта
 */
export const deliveryMenus = async ( options?: Parameters<typeof facetaFetch>[1]): Promise<deliveryMenusResponse> => {

  return facetaFetch<deliveryMenusResponse>(getDeliveryMenusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDeliveryMenusQueryKey = () => {
    return [
    `/v1/menus`
    ] as const;
    }


export const getDeliveryMenusQueryOptions = <TData = Awaited<ReturnType<typeof deliveryMenus>>, TError = ErrorModel>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryMenus>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliveryMenusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliveryMenus>>> = ({ signal }) => deliveryMenus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliveryMenus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliveryMenusQueryResult = NonNullable<Awaited<ReturnType<typeof deliveryMenus>>>
export type DeliveryMenusQueryError = ErrorModel


export function useDeliveryMenus<TData = Awaited<ReturnType<typeof deliveryMenus>>, TError = ErrorModel>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryMenus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryMenus>>,
          TError,
          Awaited<ReturnType<typeof deliveryMenus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryMenus<TData = Awaited<ReturnType<typeof deliveryMenus>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryMenus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryMenus>>,
          TError,
          Awaited<ReturnType<typeof deliveryMenus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryMenus<TData = Awaited<ReturnType<typeof deliveryMenus>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryMenus>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Меню сайта
 */

export function useDeliveryMenus<TData = Awaited<ReturnType<typeof deliveryMenus>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryMenus>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliveryMenusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliverySchemaResponse200 = {
  data: SchemaOutputBody
  status: 200
}

export type deliverySchemaResponse401 = {
  data: ErrorModel
  status: 401
}

export type deliverySchemaResponse403 = {
  data: ErrorModel
  status: 403
}

export type deliverySchemaResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliverySchemaResponseSuccess = (deliverySchemaResponse200) & {
  headers: Headers;
};
export type deliverySchemaResponseError = (deliverySchemaResponse401 | deliverySchemaResponse403 | deliverySchemaResponse500) & {
  headers: Headers;
};

export type deliverySchemaResponse = (deliverySchemaResponseSuccess | deliverySchemaResponseError)

export const getDeliverySchemaUrl = () => {




  return `/v1/schema`
}

/**
 * Коллекции, одиночки, их поля и блоки — по ним SDK генерирует TypeScript-типы сайта.
 * @summary Схема окружения
 */
export const deliverySchema = async ( options?: Parameters<typeof facetaFetch>[1]): Promise<deliverySchemaResponse> => {

  return facetaFetch<deliverySchemaResponse>(getDeliverySchemaUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDeliverySchemaQueryKey = () => {
    return [
    `/v1/schema`
    ] as const;
    }


export const getDeliverySchemaQueryOptions = <TData = Awaited<ReturnType<typeof deliverySchema>>, TError = ErrorModel>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliverySchema>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliverySchemaQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliverySchema>>> = ({ signal }) => deliverySchema({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliverySchema>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliverySchemaQueryResult = NonNullable<Awaited<ReturnType<typeof deliverySchema>>>
export type DeliverySchemaQueryError = ErrorModel


export function useDeliverySchema<TData = Awaited<ReturnType<typeof deliverySchema>>, TError = ErrorModel>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliverySchema>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliverySchema>>,
          TError,
          Awaited<ReturnType<typeof deliverySchema>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliverySchema<TData = Awaited<ReturnType<typeof deliverySchema>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliverySchema>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliverySchema>>,
          TError,
          Awaited<ReturnType<typeof deliverySchema>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliverySchema<TData = Awaited<ReturnType<typeof deliverySchema>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliverySchema>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Схема окружения
 */

export function useDeliverySchema<TData = Awaited<ReturnType<typeof deliverySchema>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliverySchema>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliverySchemaQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliveryShopCheckoutResponse201 = {
  data: CheckoutOutputBody
  status: 201
}

export type deliveryShopCheckoutResponse401 = {
  data: ErrorModel
  status: 401
}

export type deliveryShopCheckoutResponse404 = {
  data: ErrorModel
  status: 404
}

export type deliveryShopCheckoutResponse409 = {
  data: ErrorModel
  status: 409
}

export type deliveryShopCheckoutResponse422 = {
  data: ErrorModel
  status: 422
}

export type deliveryShopCheckoutResponse429 = {
  data: ErrorModel
  status: 429
}

export type deliveryShopCheckoutResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliveryShopCheckoutResponseSuccess = (deliveryShopCheckoutResponse201) & {
  headers: Headers;
};
export type deliveryShopCheckoutResponseError = (deliveryShopCheckoutResponse401 | deliveryShopCheckoutResponse404 | deliveryShopCheckoutResponse409 | deliveryShopCheckoutResponse422 | deliveryShopCheckoutResponse429 | deliveryShopCheckoutResponse500) & {
  headers: Headers;
};

export type deliveryShopCheckoutResponse = (deliveryShopCheckoutResponseSuccess | deliveryShopCheckoutResponseError)

export const getDeliveryShopCheckoutUrl = () => {




  return `/v1/shop/checkout`
}

/**
 * Гостем или с входом. Сервер проверяет товары (опубликованные, с ценой) и наличие, фиксирует цены, резервирует остатки и заводит платёж. Не хватает товара — 409 с остатками в errors (location — items.<id товара или варианта>, value — сколько осталось); ничего не заводится. Тот же предел частоты, что у записей с сайта.
 * @summary Оформить заказ
 */
export const deliveryShopCheckout = async (checkoutInputBody: NonReadonly<CheckoutInputBody>,
    headers?: DeliveryShopCheckoutHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<deliveryShopCheckoutResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<deliveryShopCheckoutResponse>(getDeliveryShopCheckoutUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(checkoutInputBody)
  }
);}





export const getDeliveryShopCheckoutQueryKey = (checkoutInputBody?: NonReadonly<CheckoutInputBody>,) => {
    return [
    'POST', `/v1/shop/checkout`, checkoutInputBody
    ] as const;
    }


export const getDeliveryShopCheckoutQueryOptions = <TData = Awaited<ReturnType<typeof deliveryShopCheckout>>, TError = ErrorModel>(checkoutInputBody: NonReadonly<CheckoutInputBody>,
    headers?: DeliveryShopCheckoutHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopCheckout>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliveryShopCheckoutQueryKey(checkoutInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliveryShopCheckout>>> = ({ signal }) => deliveryShopCheckout(checkoutInputBody,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliveryShopCheckout>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliveryShopCheckoutQueryResult = NonNullable<Awaited<ReturnType<typeof deliveryShopCheckout>>>
export type DeliveryShopCheckoutQueryError = ErrorModel


export function useDeliveryShopCheckout<TData = Awaited<ReturnType<typeof deliveryShopCheckout>>, TError = ErrorModel>(
 checkoutInputBody: NonReadonly<CheckoutInputBody>,
    headers: undefined |  DeliveryShopCheckoutHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopCheckout>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryShopCheckout>>,
          TError,
          Awaited<ReturnType<typeof deliveryShopCheckout>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryShopCheckout<TData = Awaited<ReturnType<typeof deliveryShopCheckout>>, TError = ErrorModel>(
 checkoutInputBody: NonReadonly<CheckoutInputBody>,
    headers?: DeliveryShopCheckoutHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopCheckout>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryShopCheckout>>,
          TError,
          Awaited<ReturnType<typeof deliveryShopCheckout>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryShopCheckout<TData = Awaited<ReturnType<typeof deliveryShopCheckout>>, TError = ErrorModel>(
 checkoutInputBody: NonReadonly<CheckoutInputBody>,
    headers?: DeliveryShopCheckoutHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopCheckout>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Оформить заказ
 */

export function useDeliveryShopCheckout<TData = Awaited<ReturnType<typeof deliveryShopCheckout>>, TError = ErrorModel>(
 checkoutInputBody: NonReadonly<CheckoutInputBody>,
    headers?: DeliveryShopCheckoutHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopCheckout>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliveryShopCheckoutQueryOptions(checkoutInputBody,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliveryGiftCardBuyResponse201 = {
  data: CheckoutOutputBody
  status: 201
}

export type deliveryGiftCardBuyResponse401 = {
  data: ErrorModel
  status: 401
}

export type deliveryGiftCardBuyResponse404 = {
  data: ErrorModel
  status: 404
}

export type deliveryGiftCardBuyResponse422 = {
  data: ErrorModel
  status: 422
}

export type deliveryGiftCardBuyResponse429 = {
  data: ErrorModel
  status: 429
}

export type deliveryGiftCardBuyResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliveryGiftCardBuyResponseSuccess = (deliveryGiftCardBuyResponse201) & {
  headers: Headers;
};
export type deliveryGiftCardBuyResponseError = (deliveryGiftCardBuyResponse401 | deliveryGiftCardBuyResponse404 | deliveryGiftCardBuyResponse422 | deliveryGiftCardBuyResponse429 | deliveryGiftCardBuyResponse500) & {
  headers: Headers;
};

export type deliveryGiftCardBuyResponse = (deliveryGiftCardBuyResponseSuccess | deliveryGiftCardBuyResponseError)

export const getDeliveryGiftCardBuyUrl = () => {




  return `/v1/shop/gift-cards`
}

/**
 * Заказ со свободным номиналом, оплата онлайн. После оплаты код уходит получателю письмом. Ответ — как у оформления заказа.
 * @summary Купить подарочный сертификат
 */
export const deliveryGiftCardBuy = async (giftCardBuyInputBody: NonReadonly<GiftCardBuyInputBody>,
    headers?: DeliveryGiftCardBuyHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<deliveryGiftCardBuyResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<deliveryGiftCardBuyResponse>(getDeliveryGiftCardBuyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(giftCardBuyInputBody)
  }
);}





export const getDeliveryGiftCardBuyQueryKey = (giftCardBuyInputBody?: NonReadonly<GiftCardBuyInputBody>,) => {
    return [
    'POST', `/v1/shop/gift-cards`, giftCardBuyInputBody
    ] as const;
    }


export const getDeliveryGiftCardBuyQueryOptions = <TData = Awaited<ReturnType<typeof deliveryGiftCardBuy>>, TError = ErrorModel>(giftCardBuyInputBody: NonReadonly<GiftCardBuyInputBody>,
    headers?: DeliveryGiftCardBuyHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryGiftCardBuy>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliveryGiftCardBuyQueryKey(giftCardBuyInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliveryGiftCardBuy>>> = ({ signal }) => deliveryGiftCardBuy(giftCardBuyInputBody,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliveryGiftCardBuy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliveryGiftCardBuyQueryResult = NonNullable<Awaited<ReturnType<typeof deliveryGiftCardBuy>>>
export type DeliveryGiftCardBuyQueryError = ErrorModel


export function useDeliveryGiftCardBuy<TData = Awaited<ReturnType<typeof deliveryGiftCardBuy>>, TError = ErrorModel>(
 giftCardBuyInputBody: NonReadonly<GiftCardBuyInputBody>,
    headers: undefined |  DeliveryGiftCardBuyHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryGiftCardBuy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryGiftCardBuy>>,
          TError,
          Awaited<ReturnType<typeof deliveryGiftCardBuy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryGiftCardBuy<TData = Awaited<ReturnType<typeof deliveryGiftCardBuy>>, TError = ErrorModel>(
 giftCardBuyInputBody: NonReadonly<GiftCardBuyInputBody>,
    headers?: DeliveryGiftCardBuyHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryGiftCardBuy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryGiftCardBuy>>,
          TError,
          Awaited<ReturnType<typeof deliveryGiftCardBuy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryGiftCardBuy<TData = Awaited<ReturnType<typeof deliveryGiftCardBuy>>, TError = ErrorModel>(
 giftCardBuyInputBody: NonReadonly<GiftCardBuyInputBody>,
    headers?: DeliveryGiftCardBuyHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryGiftCardBuy>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Купить подарочный сертификат
 */

export function useDeliveryGiftCardBuy<TData = Awaited<ReturnType<typeof deliveryGiftCardBuy>>, TError = ErrorModel>(
 giftCardBuyInputBody: NonReadonly<GiftCardBuyInputBody>,
    headers?: DeliveryGiftCardBuyHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryGiftCardBuy>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliveryGiftCardBuyQueryOptions(giftCardBuyInputBody,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliveryGiftCardCheckResponse200 = {
  data: GiftCardCheckOutputBody
  status: 200
}

export type deliveryGiftCardCheckResponse401 = {
  data: ErrorModel
  status: 401
}

export type deliveryGiftCardCheckResponse404 = {
  data: ErrorModel
  status: 404
}

export type deliveryGiftCardCheckResponse422 = {
  data: ErrorModel
  status: 422
}

export type deliveryGiftCardCheckResponse429 = {
  data: ErrorModel
  status: 429
}

export type deliveryGiftCardCheckResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliveryGiftCardCheckResponseSuccess = (deliveryGiftCardCheckResponse200) & {
  headers: Headers;
};
export type deliveryGiftCardCheckResponseError = (deliveryGiftCardCheckResponse401 | deliveryGiftCardCheckResponse404 | deliveryGiftCardCheckResponse422 | deliveryGiftCardCheckResponse429 | deliveryGiftCardCheckResponse500) & {
  headers: Headers;
};

export type deliveryGiftCardCheckResponse = (deliveryGiftCardCheckResponseSuccess | deliveryGiftCardCheckResponseError)

export const getDeliveryGiftCardCheckUrl = (code: string,) => {




  return `/v1/shop/gift-cards/${code}`
}

/**
 * Остаток и срок. Тот же предел частоты, что у записей с сайта: код не подобрать перебором.
 * @summary Проверить подарочный сертификат
 */
export const deliveryGiftCardCheck = async (code: string, options?: Parameters<typeof facetaFetch>[1]): Promise<deliveryGiftCardCheckResponse> => {

  return facetaFetch<deliveryGiftCardCheckResponse>(getDeliveryGiftCardCheckUrl(code),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDeliveryGiftCardCheckQueryKey = (code: string,) => {
    return [
    `/v1/shop/gift-cards/${code}`
    ] as const;
    }


export const getDeliveryGiftCardCheckQueryOptions = <TData = Awaited<ReturnType<typeof deliveryGiftCardCheck>>, TError = ErrorModel>(code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryGiftCardCheck>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliveryGiftCardCheckQueryKey(code);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliveryGiftCardCheck>>> = ({ signal }) => deliveryGiftCardCheck(code, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: code !== null && code !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliveryGiftCardCheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliveryGiftCardCheckQueryResult = NonNullable<Awaited<ReturnType<typeof deliveryGiftCardCheck>>>
export type DeliveryGiftCardCheckQueryError = ErrorModel


export function useDeliveryGiftCardCheck<TData = Awaited<ReturnType<typeof deliveryGiftCardCheck>>, TError = ErrorModel>(
 code: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryGiftCardCheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryGiftCardCheck>>,
          TError,
          Awaited<ReturnType<typeof deliveryGiftCardCheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryGiftCardCheck<TData = Awaited<ReturnType<typeof deliveryGiftCardCheck>>, TError = ErrorModel>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryGiftCardCheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryGiftCardCheck>>,
          TError,
          Awaited<ReturnType<typeof deliveryGiftCardCheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryGiftCardCheck<TData = Awaited<ReturnType<typeof deliveryGiftCardCheck>>, TError = ErrorModel>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryGiftCardCheck>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Проверить подарочный сертификат
 */

export function useDeliveryGiftCardCheck<TData = Awaited<ReturnType<typeof deliveryGiftCardCheck>>, TError = ErrorModel>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryGiftCardCheck>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliveryGiftCardCheckQueryOptions(code,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliveryShopOrdersResponse200 = {
  data: MyOrdersOutputBody
  status: 200
}

export type deliveryShopOrdersResponse401 = {
  data: ErrorModel
  status: 401
}

export type deliveryShopOrdersResponse404 = {
  data: ErrorModel
  status: 404
}

export type deliveryShopOrdersResponse422 = {
  data: ErrorModel
  status: 422
}

export type deliveryShopOrdersResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliveryShopOrdersResponseSuccess = (deliveryShopOrdersResponse200) & {
  headers: Headers;
};
export type deliveryShopOrdersResponseError = (deliveryShopOrdersResponse401 | deliveryShopOrdersResponse404 | deliveryShopOrdersResponse422 | deliveryShopOrdersResponse500) & {
  headers: Headers;
};

export type deliveryShopOrdersResponse = (deliveryShopOrdersResponseSuccess | deliveryShopOrdersResponseError)

export const getDeliveryShopOrdersUrl = () => {




  return `/v1/shop/orders`
}

/**
 * Заказы вошедшего посетителя, новые сверху.
 * @summary Мои заказы
 */
export const deliveryShopOrders = async (headers: DeliveryShopOrdersHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<deliveryShopOrdersResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<deliveryShopOrdersResponse>(getDeliveryShopOrdersUrl(),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);}





export const getDeliveryShopOrdersQueryKey = () => {
    return [
    `/v1/shop/orders`
    ] as const;
    }


export const getDeliveryShopOrdersQueryOptions = <TData = Awaited<ReturnType<typeof deliveryShopOrders>>, TError = ErrorModel>(headers: DeliveryShopOrdersHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopOrders>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliveryShopOrdersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliveryShopOrders>>> = ({ signal }) => deliveryShopOrders(headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliveryShopOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliveryShopOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof deliveryShopOrders>>>
export type DeliveryShopOrdersQueryError = ErrorModel


export function useDeliveryShopOrders<TData = Awaited<ReturnType<typeof deliveryShopOrders>>, TError = ErrorModel>(
 headers: DeliveryShopOrdersHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryShopOrders>>,
          TError,
          Awaited<ReturnType<typeof deliveryShopOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryShopOrders<TData = Awaited<ReturnType<typeof deliveryShopOrders>>, TError = ErrorModel>(
 headers: DeliveryShopOrdersHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryShopOrders>>,
          TError,
          Awaited<ReturnType<typeof deliveryShopOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryShopOrders<TData = Awaited<ReturnType<typeof deliveryShopOrders>>, TError = ErrorModel>(
 headers: DeliveryShopOrdersHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopOrders>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Мои заказы
 */

export function useDeliveryShopOrders<TData = Awaited<ReturnType<typeof deliveryShopOrders>>, TError = ErrorModel>(
 headers: DeliveryShopOrdersHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopOrders>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliveryShopOrdersQueryOptions(headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliveryShopOrderResponse200 = {
  data: OrderBody
  status: 200
}

export type deliveryShopOrderResponse401 = {
  data: ErrorModel
  status: 401
}

export type deliveryShopOrderResponse404 = {
  data: ErrorModel
  status: 404
}

export type deliveryShopOrderResponse422 = {
  data: ErrorModel
  status: 422
}

export type deliveryShopOrderResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliveryShopOrderResponseSuccess = (deliveryShopOrderResponse200) & {
  headers: Headers;
};
export type deliveryShopOrderResponseError = (deliveryShopOrderResponse401 | deliveryShopOrderResponse404 | deliveryShopOrderResponse422 | deliveryShopOrderResponse500) & {
  headers: Headers;
};

export type deliveryShopOrderResponse = (deliveryShopOrderResponseSuccess | deliveryShopOrderResponseError)

export const getDeliveryShopOrderUrl = (order: string,) => {




  return `/v1/shop/orders/${order}`
}

/**
 * По токену гостя (X-Faceta-Order-Token) или своему входу. Чужой — 404.
 * @summary Заказ
 */
export const deliveryShopOrder = async (order: string,
    headers?: DeliveryShopOrderHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<deliveryShopOrderResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<deliveryShopOrderResponse>(getDeliveryShopOrderUrl(order),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);}





export const getDeliveryShopOrderQueryKey = (order: string,) => {
    return [
    `/v1/shop/orders/${order}`
    ] as const;
    }


export const getDeliveryShopOrderQueryOptions = <TData = Awaited<ReturnType<typeof deliveryShopOrder>>, TError = ErrorModel>(order: string,
    headers?: DeliveryShopOrderHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopOrder>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliveryShopOrderQueryKey(order);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliveryShopOrder>>> = ({ signal }) => deliveryShopOrder(order,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: order !== null && order !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliveryShopOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliveryShopOrderQueryResult = NonNullable<Awaited<ReturnType<typeof deliveryShopOrder>>>
export type DeliveryShopOrderQueryError = ErrorModel


export function useDeliveryShopOrder<TData = Awaited<ReturnType<typeof deliveryShopOrder>>, TError = ErrorModel>(
 order: string,
    headers: undefined |  DeliveryShopOrderHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopOrder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryShopOrder>>,
          TError,
          Awaited<ReturnType<typeof deliveryShopOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryShopOrder<TData = Awaited<ReturnType<typeof deliveryShopOrder>>, TError = ErrorModel>(
 order: string,
    headers?: DeliveryShopOrderHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopOrder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryShopOrder>>,
          TError,
          Awaited<ReturnType<typeof deliveryShopOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryShopOrder<TData = Awaited<ReturnType<typeof deliveryShopOrder>>, TError = ErrorModel>(
 order: string,
    headers?: DeliveryShopOrderHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopOrder>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Заказ
 */

export function useDeliveryShopOrder<TData = Awaited<ReturnType<typeof deliveryShopOrder>>, TError = ErrorModel>(
 order: string,
    headers?: DeliveryShopOrderHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopOrder>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliveryShopOrderQueryOptions(order,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliveryShopCancelResponse200 = {
  data: OrderBody
  status: 200
}

export type deliveryShopCancelResponse401 = {
  data: ErrorModel
  status: 401
}

export type deliveryShopCancelResponse404 = {
  data: ErrorModel
  status: 404
}

export type deliveryShopCancelResponse409 = {
  data: ErrorModel
  status: 409
}

export type deliveryShopCancelResponse422 = {
  data: ErrorModel
  status: 422
}

export type deliveryShopCancelResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliveryShopCancelResponseSuccess = (deliveryShopCancelResponse200) & {
  headers: Headers;
};
export type deliveryShopCancelResponseError = (deliveryShopCancelResponse401 | deliveryShopCancelResponse404 | deliveryShopCancelResponse409 | deliveryShopCancelResponse422 | deliveryShopCancelResponse500) & {
  headers: Headers;
};

export type deliveryShopCancelResponse = (deliveryShopCancelResponseSuccess | deliveryShopCancelResponseError)

export const getDeliveryShopCancelUrl = (order: string,) => {




  return `/v1/shop/orders/${order}/cancel`
}

/**
 * Пока не оплачен: товар — на склад, заказ — в «отменён». Оплачен — 409: деньги возвращает магазин.
 * @summary Отменить заказ
 */
export const deliveryShopCancel = async (order: string,
    headers?: DeliveryShopCancelHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<deliveryShopCancelResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<deliveryShopCancelResponse>(getDeliveryShopCancelUrl(order),
  {
    ...options,
    method: 'POST',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);}





export const getDeliveryShopCancelQueryKey = (order: string,) => {
    return [
    'POST', `/v1/shop/orders/${order}/cancel`
    ] as const;
    }


export const getDeliveryShopCancelQueryOptions = <TData = Awaited<ReturnType<typeof deliveryShopCancel>>, TError = ErrorModel>(order: string,
    headers?: DeliveryShopCancelHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopCancel>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliveryShopCancelQueryKey(order);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliveryShopCancel>>> = ({ signal }) => deliveryShopCancel(order,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: order !== null && order !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliveryShopCancel>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliveryShopCancelQueryResult = NonNullable<Awaited<ReturnType<typeof deliveryShopCancel>>>
export type DeliveryShopCancelQueryError = ErrorModel


export function useDeliveryShopCancel<TData = Awaited<ReturnType<typeof deliveryShopCancel>>, TError = ErrorModel>(
 order: string,
    headers: undefined |  DeliveryShopCancelHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopCancel>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryShopCancel>>,
          TError,
          Awaited<ReturnType<typeof deliveryShopCancel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryShopCancel<TData = Awaited<ReturnType<typeof deliveryShopCancel>>, TError = ErrorModel>(
 order: string,
    headers?: DeliveryShopCancelHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopCancel>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryShopCancel>>,
          TError,
          Awaited<ReturnType<typeof deliveryShopCancel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryShopCancel<TData = Awaited<ReturnType<typeof deliveryShopCancel>>, TError = ErrorModel>(
 order: string,
    headers?: DeliveryShopCancelHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopCancel>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Отменить заказ
 */

export function useDeliveryShopCancel<TData = Awaited<ReturnType<typeof deliveryShopCancel>>, TError = ErrorModel>(
 order: string,
    headers?: DeliveryShopCancelHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopCancel>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliveryShopCancelQueryOptions(order,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliveryShopPayResponse200 = {
  data: PayOutputBody
  status: 200
}

export type deliveryShopPayResponse401 = {
  data: ErrorModel
  status: 401
}

export type deliveryShopPayResponse404 = {
  data: ErrorModel
  status: 404
}

export type deliveryShopPayResponse409 = {
  data: ErrorModel
  status: 409
}

export type deliveryShopPayResponse422 = {
  data: ErrorModel
  status: 422
}

export type deliveryShopPayResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliveryShopPayResponseSuccess = (deliveryShopPayResponse200) & {
  headers: Headers;
};
export type deliveryShopPayResponseError = (deliveryShopPayResponse401 | deliveryShopPayResponse404 | deliveryShopPayResponse409 | deliveryShopPayResponse422 | deliveryShopPayResponse500) & {
  headers: Headers;
};

export type deliveryShopPayResponse = (deliveryShopPayResponseSuccess | deliveryShopPayResponseError)

export const getDeliveryShopPayUrl = (order: string,) => {




  return `/v1/shop/orders/${order}/pay`
}

/**
 * Новый платёж, пока заказ ждёт оплаты. Оплачен или отменён — 409.
 * @summary Оплатить снова
 */
export const deliveryShopPay = async (order: string,
    payInputBody?: NonReadonly<PayInputBody>,
    headers?: DeliveryShopPayHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<deliveryShopPayResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<deliveryShopPayResponse>(getDeliveryShopPayUrl(order),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(payInputBody)
  }
);}





export const getDeliveryShopPayQueryKey = (order: string,
    payInputBody?: NonReadonly<PayInputBody>,) => {
    return [
    'POST', `/v1/shop/orders/${order}/pay`, payInputBody
    ] as const;
    }


export const getDeliveryShopPayQueryOptions = <TData = Awaited<ReturnType<typeof deliveryShopPay>>, TError = ErrorModel>(order: string,
    payInputBody?: NonReadonly<PayInputBody>,
    headers?: DeliveryShopPayHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopPay>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliveryShopPayQueryKey(order,payInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliveryShopPay>>> = ({ signal }) => deliveryShopPay(order,payInputBody,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: order !== null && order !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliveryShopPay>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliveryShopPayQueryResult = NonNullable<Awaited<ReturnType<typeof deliveryShopPay>>>
export type DeliveryShopPayQueryError = ErrorModel


export function useDeliveryShopPay<TData = Awaited<ReturnType<typeof deliveryShopPay>>, TError = ErrorModel>(
 order: string,
    payInputBody: undefined |  NonReadonly<PayInputBody>,
    headers: undefined |  DeliveryShopPayHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopPay>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryShopPay>>,
          TError,
          Awaited<ReturnType<typeof deliveryShopPay>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryShopPay<TData = Awaited<ReturnType<typeof deliveryShopPay>>, TError = ErrorModel>(
 order: string,
    payInputBody?: NonReadonly<PayInputBody>,
    headers?: DeliveryShopPayHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopPay>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryShopPay>>,
          TError,
          Awaited<ReturnType<typeof deliveryShopPay>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryShopPay<TData = Awaited<ReturnType<typeof deliveryShopPay>>, TError = ErrorModel>(
 order: string,
    payInputBody?: NonReadonly<PayInputBody>,
    headers?: DeliveryShopPayHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopPay>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Оплатить снова
 */

export function useDeliveryShopPay<TData = Awaited<ReturnType<typeof deliveryShopPay>>, TError = ErrorModel>(
 order: string,
    payInputBody?: NonReadonly<PayInputBody>,
    headers?: DeliveryShopPayHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopPay>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliveryShopPayQueryOptions(order,payInputBody,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliveryShopReturnResponse201 = {
  data: OrderBody
  status: 201
}

export type deliveryShopReturnResponse401 = {
  data: ErrorModel
  status: 401
}

export type deliveryShopReturnResponse404 = {
  data: ErrorModel
  status: 404
}

export type deliveryShopReturnResponse422 = {
  data: ErrorModel
  status: 422
}

export type deliveryShopReturnResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliveryShopReturnResponseSuccess = (deliveryShopReturnResponse201) & {
  headers: Headers;
};
export type deliveryShopReturnResponseError = (deliveryShopReturnResponse401 | deliveryShopReturnResponse404 | deliveryShopReturnResponse422 | deliveryShopReturnResponse500) & {
  headers: Headers;
};

export type deliveryShopReturnResponse = (deliveryShopReturnResponseSuccess | deliveryShopReturnResponseError)

export const getDeliveryShopReturnUrl = (order: string,) => {




  return `/v1/shop/orders/${order}/returns`
}

/**
 * Позиции оплаченного заказа — по токену гостя или своему входу. Деньги возвращает магазин, когда решит по заявке; решение и сумма — в returns у заказа. Больше, чем в заказе, — 422.
 * @summary Заявка на возврат
 */
export const deliveryShopReturn = async (order: string,
    returnRequestInputBody: NonReadonly<ReturnRequestInputBody>,
    headers?: DeliveryShopReturnHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<deliveryShopReturnResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<deliveryShopReturnResponse>(getDeliveryShopReturnUrl(order),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(returnRequestInputBody)
  }
);}





export const getDeliveryShopReturnQueryKey = (order: string,
    returnRequestInputBody?: NonReadonly<ReturnRequestInputBody>,) => {
    return [
    'POST', `/v1/shop/orders/${order}/returns`, returnRequestInputBody
    ] as const;
    }


export const getDeliveryShopReturnQueryOptions = <TData = Awaited<ReturnType<typeof deliveryShopReturn>>, TError = ErrorModel>(order: string,
    returnRequestInputBody: NonReadonly<ReturnRequestInputBody>,
    headers?: DeliveryShopReturnHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopReturn>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliveryShopReturnQueryKey(order,returnRequestInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliveryShopReturn>>> = ({ signal }) => deliveryShopReturn(order,returnRequestInputBody,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: order !== null && order !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliveryShopReturn>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliveryShopReturnQueryResult = NonNullable<Awaited<ReturnType<typeof deliveryShopReturn>>>
export type DeliveryShopReturnQueryError = ErrorModel


export function useDeliveryShopReturn<TData = Awaited<ReturnType<typeof deliveryShopReturn>>, TError = ErrorModel>(
 order: string,
    returnRequestInputBody: NonReadonly<ReturnRequestInputBody>,
    headers: undefined |  DeliveryShopReturnHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopReturn>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryShopReturn>>,
          TError,
          Awaited<ReturnType<typeof deliveryShopReturn>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryShopReturn<TData = Awaited<ReturnType<typeof deliveryShopReturn>>, TError = ErrorModel>(
 order: string,
    returnRequestInputBody: NonReadonly<ReturnRequestInputBody>,
    headers?: DeliveryShopReturnHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopReturn>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryShopReturn>>,
          TError,
          Awaited<ReturnType<typeof deliveryShopReturn>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryShopReturn<TData = Awaited<ReturnType<typeof deliveryShopReturn>>, TError = ErrorModel>(
 order: string,
    returnRequestInputBody: NonReadonly<ReturnRequestInputBody>,
    headers?: DeliveryShopReturnHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopReturn>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Заявка на возврат
 */

export function useDeliveryShopReturn<TData = Awaited<ReturnType<typeof deliveryShopReturn>>, TError = ErrorModel>(
 order: string,
    returnRequestInputBody: NonReadonly<ReturnRequestInputBody>,
    headers?: DeliveryShopReturnHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopReturn>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliveryShopReturnQueryOptions(order,returnRequestInputBody,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliveryShopQuoteResponse200 = {
  data: QuoteOutputBody
  status: 200
}

export type deliveryShopQuoteResponse401 = {
  data: ErrorModel
  status: 401
}

export type deliveryShopQuoteResponse404 = {
  data: ErrorModel
  status: 404
}

export type deliveryShopQuoteResponse422 = {
  data: ErrorModel
  status: 422
}

export type deliveryShopQuoteResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliveryShopQuoteResponseSuccess = (deliveryShopQuoteResponse200) & {
  headers: Headers;
};
export type deliveryShopQuoteResponseError = (deliveryShopQuoteResponse401 | deliveryShopQuoteResponse404 | deliveryShopQuoteResponse422 | deliveryShopQuoteResponse500) & {
  headers: Headers;
};

export type deliveryShopQuoteResponse = (deliveryShopQuoteResponseSuccess | deliveryShopQuoteResponseError)

export const getDeliveryShopQuoteUrl = () => {




  return `/v1/shop/quote`
}

/**
 * Цены на сейчас, скидки (лояльность и день рождения — для вошедшего, промокод) и итог — тем же расчётом, что и оформление. Неподходящий промокод — не ошибка: promo_error словами. Наличие не проверяется — его проверит оформление.
 * @summary Посчитать корзину
 */
export const deliveryShopQuote = async (quoteInputBody: NonReadonly<QuoteInputBody>,
    headers?: DeliveryShopQuoteHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<deliveryShopQuoteResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<deliveryShopQuoteResponse>(getDeliveryShopQuoteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(quoteInputBody)
  }
);}





export const getDeliveryShopQuoteQueryKey = (quoteInputBody?: NonReadonly<QuoteInputBody>,) => {
    return [
    'POST', `/v1/shop/quote`, quoteInputBody
    ] as const;
    }


export const getDeliveryShopQuoteQueryOptions = <TData = Awaited<ReturnType<typeof deliveryShopQuote>>, TError = ErrorModel>(quoteInputBody: NonReadonly<QuoteInputBody>,
    headers?: DeliveryShopQuoteHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopQuote>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliveryShopQuoteQueryKey(quoteInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliveryShopQuote>>> = ({ signal }) => deliveryShopQuote(quoteInputBody,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliveryShopQuote>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliveryShopQuoteQueryResult = NonNullable<Awaited<ReturnType<typeof deliveryShopQuote>>>
export type DeliveryShopQuoteQueryError = ErrorModel


export function useDeliveryShopQuote<TData = Awaited<ReturnType<typeof deliveryShopQuote>>, TError = ErrorModel>(
 quoteInputBody: NonReadonly<QuoteInputBody>,
    headers: undefined |  DeliveryShopQuoteHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopQuote>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryShopQuote>>,
          TError,
          Awaited<ReturnType<typeof deliveryShopQuote>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryShopQuote<TData = Awaited<ReturnType<typeof deliveryShopQuote>>, TError = ErrorModel>(
 quoteInputBody: NonReadonly<QuoteInputBody>,
    headers?: DeliveryShopQuoteHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopQuote>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryShopQuote>>,
          TError,
          Awaited<ReturnType<typeof deliveryShopQuote>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryShopQuote<TData = Awaited<ReturnType<typeof deliveryShopQuote>>, TError = ErrorModel>(
 quoteInputBody: NonReadonly<QuoteInputBody>,
    headers?: DeliveryShopQuoteHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopQuote>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Посчитать корзину
 */

export function useDeliveryShopQuote<TData = Awaited<ReturnType<typeof deliveryShopQuote>>, TError = ErrorModel>(
 quoteInputBody: NonReadonly<QuoteInputBody>,
    headers?: DeliveryShopQuoteHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryShopQuote>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliveryShopQuoteQueryOptions(quoteInputBody,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliveryStockAlertResponse204 = {
  data: void
  status: 204
}

export type deliveryStockAlertResponse401 = {
  data: ErrorModel
  status: 401
}

export type deliveryStockAlertResponse404 = {
  data: ErrorModel
  status: 404
}

export type deliveryStockAlertResponse409 = {
  data: ErrorModel
  status: 409
}

export type deliveryStockAlertResponse422 = {
  data: ErrorModel
  status: 422
}

export type deliveryStockAlertResponse429 = {
  data: ErrorModel
  status: 429
}

export type deliveryStockAlertResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliveryStockAlertResponseSuccess = (deliveryStockAlertResponse204) & {
  headers: Headers;
};
export type deliveryStockAlertResponseError = (deliveryStockAlertResponse401 | deliveryStockAlertResponse404 | deliveryStockAlertResponse409 | deliveryStockAlertResponse422 | deliveryStockAlertResponse429 | deliveryStockAlertResponse500) & {
  headers: Headers;
};

export type deliveryStockAlertResponse = (deliveryStockAlertResponseSuccess | deliveryStockAlertResponseError)

export const getDeliveryStockAlertUrl = () => {




  return `/v1/shop/stock-alerts`
}

/**
 * Почта у товара или варианта, которого нет в наличии: когда остаток снова есть, сервер пишет письмо — одно. Повторная подписка — не ошибка. Товар в наличии — 409. Тот же предел частоты, что у записей с сайта.
 * @summary Сообщить о поступлении
 */
export const deliveryStockAlert = async (stockAlertInputBody: NonReadonly<StockAlertInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<deliveryStockAlertResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<deliveryStockAlertResponse>(getDeliveryStockAlertUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(stockAlertInputBody)
  }
);}





export const getDeliveryStockAlertQueryKey = (stockAlertInputBody?: NonReadonly<StockAlertInputBody>,) => {
    return [
    'POST', `/v1/shop/stock-alerts`, stockAlertInputBody
    ] as const;
    }


export const getDeliveryStockAlertQueryOptions = <TData = Awaited<ReturnType<typeof deliveryStockAlert>>, TError = ErrorModel>(stockAlertInputBody: NonReadonly<StockAlertInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryStockAlert>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliveryStockAlertQueryKey(stockAlertInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliveryStockAlert>>> = ({ signal }) => deliveryStockAlert(stockAlertInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliveryStockAlert>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliveryStockAlertQueryResult = NonNullable<Awaited<ReturnType<typeof deliveryStockAlert>>>
export type DeliveryStockAlertQueryError = ErrorModel


export function useDeliveryStockAlert<TData = Awaited<ReturnType<typeof deliveryStockAlert>>, TError = ErrorModel>(
 stockAlertInputBody: NonReadonly<StockAlertInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryStockAlert>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryStockAlert>>,
          TError,
          Awaited<ReturnType<typeof deliveryStockAlert>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryStockAlert<TData = Awaited<ReturnType<typeof deliveryStockAlert>>, TError = ErrorModel>(
 stockAlertInputBody: NonReadonly<StockAlertInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryStockAlert>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliveryStockAlert>>,
          TError,
          Awaited<ReturnType<typeof deliveryStockAlert>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliveryStockAlert<TData = Awaited<ReturnType<typeof deliveryStockAlert>>, TError = ErrorModel>(
 stockAlertInputBody: NonReadonly<StockAlertInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryStockAlert>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Сообщить о поступлении
 */

export function useDeliveryStockAlert<TData = Awaited<ReturnType<typeof deliveryStockAlert>>, TError = ErrorModel>(
 stockAlertInputBody: NonReadonly<StockAlertInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliveryStockAlert>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliveryStockAlertQueryOptions(stockAlertInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deliverySingleResponse200 = {
  data: ItemBody
  status: 200
}

export type deliverySingleResponse401 = {
  data: ErrorModel
  status: 401
}

export type deliverySingleResponse403 = {
  data: ErrorModel
  status: 403
}

export type deliverySingleResponse404 = {
  data: ErrorModel
  status: 404
}

export type deliverySingleResponse422 = {
  data: ErrorModel
  status: 422
}

export type deliverySingleResponse500 = {
  data: ErrorModel
  status: 500
}

export type deliverySingleResponseSuccess = (deliverySingleResponse200) & {
  headers: Headers;
};
export type deliverySingleResponseError = (deliverySingleResponse401 | deliverySingleResponse403 | deliverySingleResponse404 | deliverySingleResponse422 | deliverySingleResponse500) & {
  headers: Headers;
};

export type deliverySingleResponse = (deliverySingleResponseSuccess | deliverySingleResponseError)

export const getDeliverySingleUrl = (type: string,
    params?: DeliverySingleParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/singles/${type}?${stringifiedParams}` : `/v1/singles/${type}`
}

/**
 * Единственная запись одиночного типа: настройки сайта, главная, подвал.
 * @summary Одиночка
 */
export const deliverySingle = async (type: string,
    params?: DeliverySingleParams,
    headers?: DeliverySingleHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<deliverySingleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<deliverySingleResponse>(getDeliverySingleUrl(type,params),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);}





export const getDeliverySingleQueryKey = (type: string,
    params?: DeliverySingleParams,) => {
    return [
    `/v1/singles/${type}`, ...(params ? [params] : [])
    ] as const;
    }


export const getDeliverySingleQueryOptions = <TData = Awaited<ReturnType<typeof deliverySingle>>, TError = ErrorModel>(type: string,
    params?: DeliverySingleParams,
    headers?: DeliverySingleHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliverySingle>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeliverySingleQueryKey(type,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deliverySingle>>> = ({ signal }) => deliverySingle(type,params,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: type !== null && type !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deliverySingle>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeliverySingleQueryResult = NonNullable<Awaited<ReturnType<typeof deliverySingle>>>
export type DeliverySingleQueryError = ErrorModel


export function useDeliverySingle<TData = Awaited<ReturnType<typeof deliverySingle>>, TError = ErrorModel>(
 type: string,
    params: undefined |  DeliverySingleParams,
    headers: undefined |  DeliverySingleHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliverySingle>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliverySingle>>,
          TError,
          Awaited<ReturnType<typeof deliverySingle>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliverySingle<TData = Awaited<ReturnType<typeof deliverySingle>>, TError = ErrorModel>(
 type: string,
    params?: DeliverySingleParams,
    headers?: DeliverySingleHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliverySingle>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deliverySingle>>,
          TError,
          Awaited<ReturnType<typeof deliverySingle>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeliverySingle<TData = Awaited<ReturnType<typeof deliverySingle>>, TError = ErrorModel>(
 type: string,
    params?: DeliverySingleParams,
    headers?: DeliverySingleHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliverySingle>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Одиночка
 */

export function useDeliverySingle<TData = Awaited<ReturnType<typeof deliverySingle>>, TError = ErrorModel>(
 type: string,
    params?: DeliverySingleParams,
    headers?: DeliverySingleHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deliverySingle>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeliverySingleQueryOptions(type,params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






